/**
 * StatisticDashboardContainer
 * --
 */
import React from 'react';
import StatisticDashboardPresenter from './StatisticDashboardPresenter';

const StatisticDashboardContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <StatisticDashboardPresenter />
    </>
  );
};

export default StatisticDashboardContainer;
